export const SUBSCRIBE_URL = "https://dsplp.sd.zain.com/af-lp/?p=9534921372";

export const SUBSCRIPTION_PRICE = process.env.REACT_APP_SUBSCRIPTION_PRICE || '2,036';

export const LOGO_B64 =
  "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";

export const GAMES_LIST = [
  "سباق المترو",
  "ركضة المعبد",
  "قتال الظل",
  "محارب النينجا",
  "صائد الزومبي",
  "كرة القدم الاحترافية",
  "سباق السيارات",
  "بطل التنس",
  "ركلة الجزاء",
  "سباق الدراجات",
  "سحق الحلوى",
  "رامي الفقاعات",
  "سيد السودوكو",
  "تحدي الذكاء",
  "لغز الأرقام",
  "لودو الملك",
  "سيد الشطرنج",
  "الدومينو",
  "سوليتير",
  "الطاولة",
  "الطيور الغاضبة",
  "قطع الحبل",
  "الدفاع عن البرج",
  "تقطيع الفاكهة",
  "باك مان",
  "ركضة الغابة",
  "معركة الفارس",
  "سباق الانجراف",
  "لغز الصور",
  "ماهجونج",
];

export const STATS = [
  { n: "100+", l: "لعبة متاحة" },
  { n: "24/7", l: "متاح طول الوقت" },
  { n: "0", l: "تحميل مطلوب" },
  { n: "5+", l: "فئات ألعاب" },
];

export const GAMES_GRID = [
  {
    emoji: "🏃",
    cat: "RUNNER",
    name: "سباق المترو",
    badge: "أكشن",
    bg: "linear-gradient(135deg,#0e1420,#1a1a50)",
  },
  {
    emoji: "⚽",
    cat: "SPORTS",
    name: "كرة القدم الاحترافية",
    badge: "رياضة",
    bg: "linear-gradient(135deg,#001200,#003d15)",
  },
  {
    emoji: "🍬",
    cat: "PUZZLE",
    name: "سحق الحلوى",
    badge: "بازل",
    bg: "linear-gradient(135deg,#130f30,#2d1a6e)",
  },
  {
    emoji: "🏎️",
    cat: "RACING",
    name: "سباق السيارات",
    badge: "سباق",
    bg: "linear-gradient(135deg,#1a0500,#4d1500)",
  },
  {
    emoji: "🎲",
    cat: "BOARD",
    name: "لودو الملك",
    badge: "طاولة",
    bg: "linear-gradient(135deg,#001a1a,#004040)",
  },
  {
    emoji: "🥷",
    cat: "FIGHTER",
    name: "محارب النينجا",
    badge: "قتال",
    bg: "linear-gradient(135deg,#1a0010,#4d0030)",
  },
  {
    emoji: "🏀",
    cat: "SPORTS",
    name: "تحطيم السلة",
    badge: "رياضة",
    bg: "linear-gradient(135deg,#0d1a00,#2d4d00)",
  },
  {
    emoji: "🔢",
    cat: "BRAIN",
    name: "سيد السودوكو",
    badge: "ذكاء",
    bg: "linear-gradient(135deg,#12102a,#2a1860)",
  },
  {
    emoji: "🐦",
    cat: "ARCADE",
    name: "الطيور الغاضبة",
    badge: "آركيد",
    bg: "linear-gradient(135deg,#1a0a00,#4d2a00)",
  },
  {
    emoji: "♟️",
    cat: "CLASSIC",
    name: "سيد الشطرنج",
    badge: "كلاسيك",
    bg: "linear-gradient(135deg,#001a10,#004d30)",
  },
  {
    emoji: "🍉",
    cat: "ARCADE",
    name: "تقطيع الفاكهة",
    badge: "آركيد",
    bg: "linear-gradient(135deg,#1a1000,#4d3000)",
  },
  {
    emoji: "🧟",
    cat: "DEFENSE",
    name: "صائد الزومبي",
    badge: "دفاع",
    bg: "linear-gradient(135deg,#0e1430,#1a1860)",
  },
];

export const TESTIMONIALS = [
  {
    stars: 5,
    text: '"والله شليل غيّر وقت الفراغ عندي تماماً! لعبة ورا لعبة ما بحس بالوقت بيمشي"',
    name: "محمد أحمد",
    city: "الخرطوم",
    initial: "م",
  },
  {
    stars: 5,
    text: '"كنت بلعب الألعاب التانية بس شليل خلاني أنسى كل شيء — بازل وأكشن وكورة كلها هنا!"',
    name: "سارة خالد",
    city: "أم درمان",
    initial: "س",
  },
  {
    stars: 5,
    text: '"أحسن حاجة إنو ما بنزّل حاجة — بس بفتح الموبايل وألعب. سريع وما في مشاكل أبداً"',
    name: "ياسر محمود",
    city: "بورتسودان",
    initial: "ي",
  },
  {
    stars: 5,
    text: '"تحديت صاحبي في لودو وشطرنج وأنا كسبت! شليل عمل مني بطل 😂"',
    name: "عمر إبراهيم",
    city: "كسلا",
    initial: "ع",
  },
  {
    stars: 5,
    text: '"الأسعار كويسة وفيها ألعاب كتير. الأطفال والكبار كلهم بيلعبوا عندنا في البيت!"',
    name: "هناء عبدالله",
    city: "الأبيض",
    initial: "ه",
  },
  {
    stars: 5,
    text: '"حتى لما النت شوية بطيء شليل بيشتغل كويس — ده اللي عجبني أكتر!"',
    name: "طارق النور",
    city: "مدني",
    initial: "ط",
  },
];

export const FAQ = [
  {
    q: "لازم أنزّل تطبيق؟",
    a: "لا أبداً! شليل بيشتغل مباشرة من متصفح موبايلك — افتح الموقع والعب على طول بدون أي تحميل.",
  },
  {
    q: "الاشتراك يعمل على أي جهاز؟",
    a: "يعمل على أي موبايل أندرويد أو آيفون، وكمان على التابلت واللاب توب. المهم عندك اتصال بالشبكة.",
  },
  {
    q: "النت عندي بطيء — شليل بيشتغل؟",
    a: "أيوه! الألعاب عندنا خفيفة ومصممة تشتغل حتى مع النت البطيء — ما بتحتاج نت سريع.",
  },
  {
    q: "كيف أوقف الاشتراك لو ما أريد أكمل؟",
    a: "سهل جداً — تقدر توقف الاشتراك في أي وقت من موقع شليل أو عبر رسالة نصية قصيرة.",
  },
  {
    q: "ألعاب جديدة بتضيف؟",
    a: "أيوه! بنضيف ألعاب جديدة باستمرار علشان ما تحس بالملل — دايماً في جديد ينتظرك في شليل.",
  },
  {
    q: "في ألعاب للأطفال؟",
    a: "أيوه! شليل عنده ألعاب مناسبة لكل الأعمار من الأطفال للكبار — الكل يلعب ويستمتع.",
  },
];
